"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanBooking = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var loan_1 = require("../../model/loan");
var service_1 = require("../../../library/base/service");
var LoanBooking = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(LoanBooking, _super);
    function LoanBooking() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '预约贷款提交接口';
        _this.code = '101076';
        _this.desc = '预约贷款提交接口';
        _this.requestParams = new loan_1.LoanBookingRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return LoanBooking;
}(service_1.BaseService));
exports.LoanBooking = LoanBooking;
//# sourceMappingURL=loanBooking.js.map